var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V3.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V3.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V3.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.1046 3 14 3.89543 14 5V9.88281C13.7349 9.64477 13.3845 9.5 13 9.5C12.6155 9.5 12.2651 9.64477 12 9.88281V7.40039C12 7.17948 11.8205 7 11.5996 7H10.4004C10.1795 7 10 7.17948 10 7.40039V11.5996C10 11.8205 10.1795 12 10.4004 12H10.5C10.5 12.6772 10.9491 13.2481 11.5654 13.4346C11.6297 13.647 11.7405 13.8388 11.8848 14H4C2.89543 14 2 13.1046 2 12V5C2 3.89543 2.89543 3 4 3H12ZM4.40039 7C4.17948 7 4 7.17948 4 7.40039V11.5996C4 11.8205 4.17948 12 4.40039 12H5.59961C5.82052 12 6 11.8205 6 11.5996V7.40039C6 7.17948 5.82052 7 5.59961 7H4.40039ZM7.40039 7C7.17948 7 7 7.17948 7 7.40039V11.5996C7 11.8205 7.17948 12 7.40039 12H8.59961C8.82052 12 9 11.8205 9 11.5996V7.40039C9 7.17948 8.82052 7 8.59961 7H7.40039ZM3.90039 5C3.67948 5 3.5 5.17948 3.5 5.40039V5.59961C3.5 5.82052 3.67948 6 3.90039 6H12.0996C12.3205 6 12.5 5.82052 12.5 5.59961V5.40039C12.5 5.17948 12.3205 5 12.0996 5H3.90039Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14M13 11V13",
    stroke: "currentColor",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAdd);
export default __webpack_public_path__ + "static/media/calendar-add.ce4e093f38d6538f040dd9a54b0950dd.svg";
export { ForwardRef as ReactComponent };